import { Flex } from '@aloft/toolkit-sui';

import { PropsWithChildren } from 'react';

import { popoverInputFocusSx } from '../styles.ts';
import { PROPERTY_GRID_ROW_HEIGHT } from '../../consts.ts';

type PopoverInputHeaderProps = PropsWithChildren<{
  inputFocused: boolean;
}>;

export const PopoverInputHeader = ({ inputFocused, children }: PopoverInputHeaderProps) => (
  <Flex
    alignItems="center"
    justifyContent="space-between"
    width="100%"
    height={PROPERTY_GRID_ROW_HEIGHT}
    gap="4px"
    padding="4px 8px"
    borderWidth="0px"
    borderStyle="solid"
    borderColor="strokeDefault"
    borderBottomWidth="1px"
    __dangerDoNotUseSx={{
      ...(inputFocused && popoverInputFocusSx),
    }}
  >
    {children}
  </Flex>
);
